<sz-app-shell>
  <sz-top-bar />
  <div class="drills-list">
    <div class="drills-list__header">
      <sz-page-title [title]="'drills.list.title' | translate" size="xl" />
      <sz-button variant="primary" size="sm" class="drills-list__create-btn" (click)="goToCreateDrill()">
        <sz-icon name="plus" [size]="14" />
        {{ 'drills.list.createCta' | translate }}
      </sz-button>
    </div>

    <sz-search-input
      class="drills-list__search"
      [placeholder]="'drills.list.searchPlaceholder' | translate"
      [ngModel]="searchQuery()"
      (ngModelChange)="setSearch($event)" />

    <div class="drills-list__filters">
      <lib-drills-list-type-filter [active]="typeFilter()" (activeChange)="setTypeFilter($event)" />
      <lib-drills-list-tabs [active]="activeTab()" (activeChange)="setTab($event)" />
    </div>

    <sz-section-head [label]="'drills.list.sectionLabel' | translate" [count]="visibleDrills().length" />

    <div class="drills-list__items">
      @if (list() === null) {
        <sz-skeleton shape="block" height="64px" />
        <sz-skeleton shape="block" height="64px" />
        <sz-skeleton shape="block" height="64px" />
        <sz-skeleton shape="block" height="64px" />
      } @else {
        @for (drill of visibleDrills(); track drill.id) {
          <lib-drill-list-item
            [drill]="drill"
            variant="flat"
            (favoriteToggle)="toggleFavorite(drill.id)"
            (select)="goToDrillDetail(drill.id)" />
        } @empty {
          <p class="drills-list__empty">{{ 'drills.list.empty' | translate }}</p>
        }
      }
    </div>
  </div>
</sz-app-shell>
